<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
      <!-- <template v-slot:divider>
        <v-icon>mdi-forward</v-icon>
      </template> -->
    </v-breadcrumbs>

    <!-- <v-card> -->
    <v-row dense
           class="d-flex mx-16">

      <v-col cols="3">
        <v-btn icon
               small
               outlined
               @click="showOrHide()">
          <v-icon v-if="isShowFilter">mdi-chevron-double-left</v-icon>
          <v-icon v-else>mdi-chevron-double-right</v-icon>
        </v-btn>
      </v-col>

      <v-col :cols="col2">
        <v-alert color="info"
                 text
                 dense>
          <v-icon dark
                  color="info"
                  v-show="isShowTips">mdi-hand-pointing-left</v-icon>
          <span class="ml-2"
                v-show="isShowTips">Start searching by selecting one or more fields</span>
          <v-btn small
                 color="error"
                 class="mx-1"
                 @click="refreshAll()"
                 v-show="!isShowTips">
            <v-icon left>mdi-refresh</v-icon>
            Clear
          </v-btn>

          <!-- source_selected -->
          <v-btn v-show="source_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshSource()">Source</v-btn>
          <v-btn v-show="source_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="source_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="source_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(source, index) in source_selected"
               :key="source">
            <v-btn v-show="source_selected.length > 0 && index < source_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="source_selected.splice(index, 1);
                            loading = true;
                             getSpliceDatasets();
                             source_selected_show = source_selected.length;">
              {{source}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == source_selected_show"
                   @click="source_selected_show=source_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="source_selected_show > 2"
                 @click="source_selected_show=2">...Less</v-btn>
          <span v-show="source_selected.length > 1">)</span>
          <v-btn v-show="source_selected.length>0 && project_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- project_selected -->
          <v-btn v-show="project_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshProject()">Project ID</v-btn>
          <v-btn v-show="project_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="project_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="project_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(project, index) in project_selected"
               :key="project">
            <v-btn v-show="project_selected.length > 0 && index < project_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="project_selected.splice(index, 1);
                     loading = true;
                     getSpliceDatasets();
                     project_selected_show = project_selected.length;">
              {{project}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == project_selected_show"
                   @click="project_selected_show=project_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="project_selected_show > 2"
                 @click="project_selected_show=2">...Less</v-btn>
          <span v-show="project_selected.length > 1">)</span>
          <v-btn v-show="project_selected.length > 0 && cancer_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- cancer_selected -->
          <v-btn v-show="cancer_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshCancer()">Cancer Type</v-btn>
          <v-btn v-show="cancer_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="cancer_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="cancer_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(cancer, index) in cancer_selected"
               :key="cancer">
            <v-btn v-show="cancer_selected.length > 0 && index < cancer_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="cancer_selected.splice(index, 1);
                    cancer_selected_show = cancer_selected.length;
                    loading = true;
                    getSpliceDatasets();">
              {{cancer}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == cancer_selected_show"
                   @click="cancer_selected_show=cancer_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="cancer_selected_show > 2"
                 @click="cancer_selected_show=2">...Less</v-btn>
          <span v-show="cancer_selected.length > 1">)</span>
          <v-btn v-show="cancer_selected.length>0 && gene_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- gene_selected -->
          <v-btn v-show="gene_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshGene()">Gene Name</v-btn>
          <v-btn v-show="gene_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="gene_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="gene_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(gene, index) in gene_selected"
               :key="gene">
            <v-btn v-show="gene_selected.length > 0 && index < gene_selected_show"
                   class="mx-1 mt-1"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   small
                   color="info"
                   @click="gene_selected.splice(index, 1);
                     loading = true;
                     getSpliceDatasets();
                     gene_selected_show = gene_selected.length;">
              {{gene}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == gene_selected_show"
                   @click="gene_selected_show=gene_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="gene_selected_show > 3"
                 @click="gene_selected_show=3">...Less</v-btn>
          <span v-show="gene_selected.length > 1">)</span>
          <v-btn v-show="gene_selected.length > 0 && as_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- as_selected -->
          <v-btn v-show="as_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshASType()">AS Type</v-btn>
          <v-btn v-show="as_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="as_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="as_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(as, index) in as_selected"
               :key="as">
            <v-btn v-show="as_selected.length > 0 && index < as_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="as_selected.splice(index, 1);
                     loading = true;
                     getSpliceDatasets();
                     as_selected_show = as_selected.length;">
              {{as}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == as_selected_show"
                   @click="as_selected_show=as_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="as_selected_show > 3"
                 @click="as_selected_show=3">...Less</v-btn>
          <span v-show="as_selected.length > 1">)</span>
          <v-btn v-show="as_selected.length > 0 && site_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- site_selected -->
          <v-btn v-show="site_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshSite()">Primary Site</v-btn>
          <v-btn v-show="site_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="site_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="site_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(site, index) in site_selected"
               :key="site">
            <v-btn v-show="site_selected.length > 0 && index < site_selected_show"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="site_selected.splice(index, 1);
                     loading = true;
                     getSpliceDatasets();
                     site_selected_show = site_selected.length;">
              {{site}}
            </v-btn>
            <v-btn class="mx-1 grey--text text-caption"
                   text
                   small
                   outlined
                   v-show="index == site_selected_show"
                   @click="site_selected_show=site_selected.length">More...</v-btn>
          </div>
          <v-btn class="mx-1 grey--text text-caption"
                 text
                 small
                 outlined
                 v-show="site_selected_show > 3"
                 @click="site_selected_show=3">...Less</v-btn>
          <span v-show="site_selected.length > 1">)</span>
          <v-btn v-show="site_selected.length > 0 && dase_selected.length > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- dase_selected -->
          <v-btn v-show="dase_selected.length > 0"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshDASE()">DASE</v-btn>
          <v-btn v-show="dase_selected.length == 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IS</v-btn>
          <v-btn v-show="dase_selected.length > 1"
                 small
                 color="success"
                 class="mx-1 disable-cursor">IN</v-btn>
          <span v-show="dase_selected.length > 1">(</span>
          <div class="v-item-group"
               v-for="(dase, index) in dase_selected"
               :key="index">
            <v-btn v-show="dase_selected.length > 0"
                   class="mx-1 mt-1"
                   small
                   color="info"
                   @mouseenter="addDeleteLine($event)"
                   @mouseleave="removeDeleteLine($event)"
                   @click="dase_selected.splice(index, 1);
                     loading = true;
                     getSpliceDatasets();">
              {{dase}}
            </v-btn>
          </div>
          <span v-show="dase_selected.length > 1">)</span>
          <v-btn v-show="dase_selected.length > 0 && dpsi_selected > 0"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- dpsi_selected -->
          <v-btn v-show="dpsi_selected"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshDpsi()">Delta PSI</v-btn>
          <v-btn v-show="dpsi_selected"
                 small
                 color="success"
                 class="mx-1 disable-cursor">≥</v-btn>
          <v-btn v-show="dpsi_selected"
                 class="mx-1"
                 small
                 color="info"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshDpsi()">
            {{dpsi_selected}}
          </v-btn>
          <v-btn v-show="dpsi_selected && fdr_selected"
                 small
                 color="success"
                 class="mx-1 disable-cursor">AND</v-btn>

          <!-- fdr_selected -->
          <v-btn v-show="fdr_selected"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshFDR()">FDR</v-btn>
          <v-btn v-show="fdr_selected"
                 small
                 color="success"
                 class="mx-1 disable-cursor">≤</v-btn>
          <v-btn v-show="fdr_selected"
                 class="mx-1"
                 small
                 color="info"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshFDR()">
            {{fdr_selected}}
          </v-btn>
        </v-alert>
      </v-col>

      <v-col cols="3"
             v-show="isShowFilter">
        <v-list outlined
                rounded
                dense>
          <!-- Source -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Source(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="source_selected.length > 0"
                      @click.stop="refreshSource()">mdi-refresh</v-icon>
            </template>
            <v-chip-group class="mx-6"
                          v-model="source_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(source, index) in source_items"
                   :key="index">
                <v-chip small
                        filter
                        :value="source">
                  <span>
                    {{ source }}
                  </span>
                </v-chip>
              </div>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Project ID -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Project ID(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="project_selected.length > 0"
                      @click.stop="refreshProject()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Project ID"
                        v-model="project_selected"
                        outlined
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="project_loading"
                        :items="project_items"
                        :search-input.sync="project_search"
                        :messages="project_message"
                        :error-messages="project_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2"
                        small>
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 2"
                      class="grey--text text-caption">
                  (+{{ project_selected.length - 2 }} More)
                </span>
              </template>
            </v-combobox>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Cancer Type -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Cancer Type(s)</v-list-item-title>
              <v-icon right
                      @click.stop="isShowCancerSearchBox = !isShowCancerSearchBox">mdi-magnify</v-icon>
              <v-icon right
                      v-show="cancer_selected.length > 0"
                      @click.stop="refreshCancer()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Cancer Type"
                        v-show="isShowCancerSearchBox"
                        v-model="cancer_select"
                        hide-no-data
                        outlined
                        dense
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="cancer_loading"
                        :search-input.sync="cancer_search"
                        :error-messages="cancer_error_message">
            </v-combobox>
            <v-chip-group class="mx-6"
                          v-model="cancer_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(cancer, index) in cancer_items"
                   :key="index">
                <v-chip small
                        filter
                        :value="cancer"
                        v-show="index < cancer_index">
                  <span>
                    {{ cancer }}
                  </span>
                </v-chip>
                <v-btn class="grey--text text-caption"
                       text
                       small
                       outlined
                       v-show="index == cancer_index"
                       @click="showMoreCancer()">(+{{ cancer_items.length - cancer_index }} More)
                </v-btn>
              </div>
              <v-btn class="grey--text text-caption"
                     text
                     small
                     outlined
                     v-show="cancer_index == cancer_items.length"
                     @click="showLessCancer()">Less
              </v-btn>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Gene Name -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Gene Name(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="gene_selected.length > 0"
                      @click.stop="refreshGene()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Gene Name"
                        v-model="gene_selected"
                        outlined
                        dense
                        hide-no-data
                        hide-selected
                        multiple
                        small-chips
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="gene_loading"
                        :items="gene_items"
                        :search-input.sync="gene_search"
                        :messages="gene_message"
                        :error-messages="gene_error_message">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3"
                        small>
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index == 3"
                      class="grey--text text-caption">
                  (+{{ gene_selected.length - 3 }} More)
                </span>
              </template>
            </v-combobox>
          </v-list-group>
          <v-divider></v-divider>

          <!-- AS Type -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>AS Type(s)</v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="as_selected.length > 0"
                      @click.stop="refreshASType()">mdi-refresh</v-icon>
            </template>
            <v-chip-group class="mx-6"
                          v-model="as_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(astype, index) in as_items"
                   :key="index">
                <v-chip small
                        filter
                        :value="astype">
                  <span>
                    {{ astype }}
                  </span>
                </v-chip>
              </div>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Primary Site -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Primary Site(s)</v-list-item-title>
              <v-icon right
                      @click.stop="isShowSiteSearchBox = !isShowSiteSearchBox">mdi-magnify</v-icon>
              <v-icon right
                      v-show="site_selected.length > 0"
                      @click.stop="refreshSite()">mdi-refresh</v-icon>
            </template>
            <v-combobox class="mx-6"
                        label="Primary Site"
                        v-show="isShowSiteSearchBox"
                        v-model="site_select"
                        hide-no-data
                        outlined
                        dense
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="site_loading"
                        :search-input.sync="site_search"
                        :error-messages="site_error_message">
            </v-combobox>
            <v-chip-group class="mx-6"
                          v-model="site_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(site, index) in site_items"
                   :key="index">
                <v-chip small
                        filter
                        :value="site"
                        v-show="index < site_index">
                  <span>
                    {{ site }}
                  </span>
                </v-chip>
                <v-btn class="grey--text text-caption"
                       text
                       small
                       outlined
                       v-show="index == site_index"
                       @click="showMoreSite()">(+{{ site_items.length - site_index }} More)
                </v-btn>
              </div>
              <v-btn class="grey--text text-caption"
                     text
                     small
                     outlined
                     v-show="site_index == site_items.length"
                     @click="showLessSite()">Less
              </v-btn>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- DASE -->
          <v-list-group append-icon=""
                        dense>
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>DASE
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon x-small
                            v-bind="attrs"
                            v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Differential Alternative Splicing Events</span><br>
                  <span>Filter criteria: |Delta PSI| > 0.1 & FDR < 0.05</span>
                </v-tooltip>
              </v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="dase_selected.length > 0"
                      @click.stop="refreshDASE()">mdi-refresh</v-icon>
            </template>
            <v-chip-group class="mx-6"
                          v-model="dase_selected"
                          multiple
                          column
                          center-active>
              <div v-for="(dase, index) in dase_items"
                   :key="index">
                <v-chip small
                        filter
                        :value="dase">
                  <span>
                    {{ dase }}
                  </span>
                </v-chip>
              </div>
            </v-chip-group>
          </v-list-group>
          <v-divider></v-divider>

          <!-- Delta PSI -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>Delta PSI
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon x-small
                            v-bind="attrs"
                            v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Delta PSI = PSI Tumor - PSI Normal</span>
                </v-tooltip>
              </v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="dpsi_selected != 0"
                      @click.stop="refreshDpsi()">mdi-refresh</v-icon>
            </template>
            <v-slider min="0"
                      max="1"
                      class="mx-6"
                      label="|Delta PSI| ≥"
                      v-model="dpsi_selected"
                      thumb-label
                      thumb-color="primary"
                      dense
                      step="0.05"
                      ticks="always"></v-slider>
          </v-list-group>
          <v-divider></v-divider>

          <!-- FDR -->
          <v-list-group append-icon="">
            <template v-slot:activator>
              <v-icon left>mdi-menu-right</v-icon>
              <v-list-item-title>FDR
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon x-small
                            v-bind="attrs"
                            v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>FDR value in Wilcoxon test</span>
                </v-tooltip>
              </v-list-item-title>
              <v-icon right>mdi-magnify</v-icon>
              <v-icon right
                      v-show="fdr_selected != 0"
                      @click.stop="refreshFDR()">mdi-refresh</v-icon>
            </template>
            <v-slider min="0"
                      max="0.1"
                      class="mx-6"
                      label="FDR ≤"
                      v-model="fdr_selected"
                      thumb-label
                      thumb-color="primary"
                      dense
                      step="0.01"
                      ticks="always"></v-slider>
          </v-list-group>
          <!-- <v-divider></v-divider> -->
        </v-list>
      </v-col>
      <v-col :cols="col2">
        <!-- download function -->
        <div class="my-3"
             v-if="selected.length > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success"
                     dark
                     v-bind="attrs"
                     v-on="on"
                     rounded
                     small
                     class="ml-2">
                <span class="font-weight-bold">Download</span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="xls"
                              :data="selected"
                              name="Computationally_predicted_AS_events.xls">
                    <v-btn text
                           block> <span class="font-weight-bold">xls</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="csv"
                              :data="selected"
                              name="Computationally_predicted_AS_events.csv">
                    <v-btn text
                           block> <span class="font-weight-bold">csv</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-expansion-panels class="data-table-style">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      class="data-table-style mt-1"
                      :headers="selectedHeaders"
                      fixed-header
                      :items="filteredSpliceDatasets"
                      v-model="selected"
                      item-key="_id"
                      :search="search"
                      show-select
                      :single-select="singleSelect"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      :page.sync="currentPage"
                      :items-per-page="pageSize"
                      hide-default-footer
                      v-show="selectedHeaders && selectedHeaders.length > 0">
          <!-- item.event_id slot -->
          <template v-slot:[`item.event_id`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.event_id}}</span>
              </template>
              <span><span class="error--text font-weight-bold">Event ID: </span> Gene _ Chromsome _ Strand _ AS Type _ Event Coordinates</span>
            </v-tooltip>
          </template>
          <!-- item.as_model_id slot -->
          <template v-slot:[`item.as_model_id`]="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                      v-on="on">{{item.as_model_id}}</span>
              </template>
              <span><span class="error--text font-weight-bold">AS Model ID: </span> Gene _ Chromsome _ Strand _ AS Type _ AS Model Coordinates</span>
            </v-tooltip>
          </template>
          <!-- item.gene_name slot -->
          <template v-slot:[`item.gene_name`]="{item}">
            <a @click="goToGeneSearchResult(item.gene_name)">
              <span class="font-weight-bold">{{item.gene_name}}</span>
            </a>
          </template>
          <!-- header.pct_samples slot -->
          <template v-slot:[`header.pct_samples`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Percent of samples with PSI values</span>
            </v-tooltip>
          </template>
          <!-- header.dpsi slot -->
          <template v-slot:[`header.dpsi`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Delta PSI = PSI Tumor - PSI Normal</span>
            </v-tooltip>
          </template>
          <!-- header.pvalue slot -->
          <template v-slot:[`header.pvalue`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>p value in Wilcoxon test</span>
            </v-tooltip>
          </template>
          <!-- header.fdr slot -->
          <template v-slot:[`header.fdr`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>FDR value in Wilcoxon test</span>
            </v-tooltip>
          </template>
          <!-- header.is_dase slot -->
          <template v-slot:[`header.is_dase`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Differential Alternative Splicing Events</span><br>
              <span>Filter criteria: |Delta PSI| > 0.1 & FDR < 0.05</span>
            </v-tooltip>
          </template>

          <!-- header.regulatory_explorer slot -->
          <template v-slot:[`header.regulatory_explorer`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Splicing Regulatory Explorer</span>
            </v-tooltip>
          </template>

          <!-- header.survival slot -->
          <template v-slot:[`header.survival`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Survival Analysis</span>
            </v-tooltip>
          </template>

          <!-- header.staging slot -->
          <template v-slot:[`header.staging`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Cancer Staging Analysis</span>
            </v-tooltip>
          </template>

          <!-- item.visualization slot -->
          <template v-slot:[`item.visualization`]="{item}">
            <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
                   color="info"
                   icon
                   :disabled="item.as_type == 'Complex'">
              <v-icon>mdi-tune</v-icon>
            </v-btn>
          </template>

          <!-- item.regulatory_explorer slot -->
          <template v-slot:[`item.regulatory_explorer`]="{item}">
            <v-btn @click="goToRegulationExplorer(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                   color="grey"
                   icon
                   :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.source != 'TCGA' || item.as_type == 'Complex' || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                <use xlink:href="#icon-GridView-diable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-GridView-oncoprint"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.survival slot -->
          <template v-slot:[`item.survival`]="{item}">
            <v-btn @click="goToSurvival(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                   color="info"
                   icon
                   :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || !survival_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.source != 'TCGA' || item.as_type == 'Complex' || !survival_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                <use xlink:href="#icon-linechart-diable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-linechart"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.staging slot -->
          <template v-slot:[`item.staging`]="{item}">
            <v-btn @click="goToStaging(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                   color="info"
                   icon
                   :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || !stage_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.source != 'TCGA' || item.as_type == 'Complex' || !stage_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                <use xlink:href="#icon-xiangxiantu-disable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-xiangxiantu"></use>
              </svg>
            </v-btn>
          </template>

          <!-- header.data-table-select slot-->
          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox color="success"
                               v-bind="props"
                               v-on="on"></v-simple-checkbox>
          </template>

          <!-- item.data-table-select slot -->
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox color="info"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </template>
        </v-data-table>

        <div class="d-flex justify-center mt-2 mb-n5">
          <span class="text-body-1 mt-3">Items per page</span>
          <v-select v-model="pageSize"
                    dense
                    outlined
                    :items="pageSizes"
                    class="pagesize-select mt-1 mx-2"
                    @input="handlePageSizeChange(pageSize)">
          </v-select>
          <span class="text-body-1 mt-3 mx-2">Total <span class="font-weight-bold info--text">{{totalItems}}</span>
            items </span>
          <v-pagination v-model="currentPage"
                        color="info"
                        :length="totalPages"
                        :total-visible="8"
                        class="mx-1"
                        @input="handlePageChange"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right">
          </v-pagination>
          <!-- <span class="text-body-1 mt-2 mx-2">Page</span>
            <v-text-field outlined
                          dense
                          v-model="whichPage"
                          type="number"
                          class="jump-select"
                          append-icon="">
            </v-text-field>
            <v-btn color=""
                   depressed
                   outlined
                   class="mx-2"
                   @click="jumpPage()">Jump</v-btn> -->
        </div>
      </v-col>
    </v-row>
    <!-- </v-card> -->

    <back-to-top></back-to-top>
  </v-container>
</template>

<script>
import {
  getSpliceDatasets,
  getAllCancerFromSpliceDataset,
  getAllPrimarySiteFromSpliceDataset,
  getAllProjectFromSpliceDataset
} from 'node/browse.js'
import { getAllGeneNamesFromGeneInfo } from 'node/general';
import JsonExcel from 'vue-json-excel';
import BackToTop from '@/components/main/BackToTop';

export default {
  name: 'Datasets',
  components: {
    JsonExcel,
    BackToTop
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Browse',
          disabled: true,
        },
        {
          text: 'CPSE (Computationally Putative Splicing Events)',
          disabled: true,
        },
      ],
      isShowFilter: true,
      col2: 9,

      isShowTips: true,
      isShowAnd: false,
      isShowDeleteLine: false,

      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      currentPage: 1,
      whichPage: 1,
      totalPages: 8,
      pageSize: 9,
      pageSizes: [9, 15, 20, 50, 100],
      totalItems: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: 0,
      nextPage: 0,

      selectedHeader: ['BioProject', 'Gene Name', 'Cancer Type', 'AS Type',
        'ORF', 'PSI Tumor', 'PSI Normal', 'Delta PSI', 'FDR',
        'DASE', 'Visualization', 'Explorer', 'Survival', 'Staging'],
      headers: [
        { text: 'Event ID', value: 'event_id', align: 'start', sortable: false, },
        { text: 'AS Model ID', value: 'as_model_id', align: 'start', sortable: false, },
        { text: 'Source', value: 'source', align: 'start', sortable: false, },
        { text: 'BioProject', value: 'project_id', align: 'start', sortable: false, },
        { text: 'Gene Name', value: 'gene_name', align: 'start', sortable: true, },
        { text: 'Chr', value: 'chr', align: 'start', sortable: true, },
        { text: 'Strand', value: 'strand', align: 'start', sortable: true, },
        { text: 'Cancer Type', value: 'cancer_name', align: 'start', sortable: true },
        { text: 'Primary Site', value: 'primary_site', align: 'start' },
        { text: 'AS Type', value: 'as_type', align: 'start' },
        { text: 'Event Coordinates', value: 'event_coordinates', align: 'start', },
        { text: 'Alt Coordinates', value: 'alt_coordinates', align: 'start', sortable: false, },
        { text: 'ORF', value: 'orf', align: 'start', sortable: false, },
        { text: 'Control', value: 'control', align: 'start', sortable: true, },
        { text: 'Control Size', value: 'control_size', align: 'start', sortable: false, },
        { text: 'Case', value: 'case', align: 'start', sortable: false, },
        { text: 'Case Size', value: 'case_size', align: 'start', sortable: false, },
        { text: 'Percent Samples', value: 'pct_samples', align: 'start', sortable: false, },
        { text: 'PSI Tumor', value: 'tumor_psi', align: 'start', sortable: false, },
        { text: 'PSI Normal', value: 'normal_psi', align: 'start', sortable: false, },
        { text: 'Delta PSI', value: 'dpsi', align: 'start', sortable: false, },
        { text: 'P Value', value: 'pvalue', align: 'start', sortable: false, },
        { text: 'FDR', value: 'fdr', align: 'start', sortable: false, },
        { text: 'DASE', value: 'is_dase', align: 'start', sortable: false, },
        { text: 'Visualization', value: 'visualization', align: 'center', sortable: false, },
        { text: 'Explorer', value: 'regulatory_explorer', align: 'center', sortable: false, },
        { text: 'Survival', value: 'survival', align: 'center', sortable: false, },
        { text: 'Staging', value: 'staging', align: 'center', sortable: false, },
      ],

      splice_datasets: [],

      // Filter by Source:
      source_selected: [],
      // source_items: ["TCGA", "GTEx", "GEO"],
      source_items: ["TCGA", "GTEx"],
      source_selected_show: 2,

      // Filter by Project ID:
      project_selected: [],
      project_search: null,
      project_list: [],
      project_items: [],
      project_loading: false,
      project_message: "Please enter 1 or more project names.",
      project_error_message: null,
      project_selected_show: 2,

      // Filter by Cancer Type:
      cancer_selected: [],
      cancer_select: null,
      cancer_search: null,
      cancer_list: [],
      cancer_items: [],
      cancer_loading: false,
      cancer_error_message: null,
      cancer_index: 6,
      isShowCancerSearchBox: true,
      cancer_selected_show: 2,

      // Filter by Gene Name:
      gene_selected: [],
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: "Please enter 1 or more gene names.",
      gene_error_message: null,
      gene_selected_show: 3,

      // Filter by AS Type:
      as_selected: [],
      as_items: ["ES", "A3SS", "A5SS", "IR", "MEX"],
      as_selected_show: 3,

      // Filter by Primary Site
      site_selected: [],
      site_select: null,
      site_search: null,
      site_list: [],
      site_items: [],
      site_loading: false,
      site_error_message: null,
      site_index: 6,
      isShowSiteSearchBox: true,
      site_selected_show: 3,

      // Filter by is_DASE
      dase_selected: [],
      dase_items: ["yes", "no"],

      // Filter by delta_psi
      dpsi_selected: 0,

      // Filter by fdr
      fdr_selected: 0,


      survival_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO",
        "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD", "TCGA-READ", "TCGA-SARC",
        "TCGA-SKCM", "TCGA-STAD", "TCGA-THCA", "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ],
      stage_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-ESCA", "TCGA-HNSC", "TCGA-KICH", "TCGA-KIRC", "TCGA-KIRP",
        "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO", "TCGA-PAAD", "TCGA-READ", "TCGA-SKCM",
        "TCGA-STAD", "TCGA-THCA",
      ],

    }
  },
  created() {
    this.getAllProjectFromSpliceDataset()
    this.getAllCancerFromSpliceDataset();
    this.getAllPrimarySiteFromSpliceDataset();
    this.getAllGeneNamesFromGeneInfo().then(() => {
      // console.log(this.$route.query);

      if (Object.keys(this.$route.query).length == 0) {
        // console.log('hahaha');
        this.getSpliceDatasets();

      } else if (Object.keys(this.$route.query).length == 3 && this.$route.query.page
        && this.$route.query.size && this.$route.query.showpages) {
        // console.log('hahaha');
        // this.currentPage = +this.$route.query.page;
        // this.pageSize = +this.$route.query.size;
        // this.totalPages = +this.$route.query.showpages;
        this.currentPage = 1;
        this.pageSize = 9;
        this.totalPages = 8;
        this.getSpliceDatasets();

      } else if (Object.keys(this.$route.query).length >= 3) {
        // console.log('hahaha');
        // console.log(this.$route.query);
        // this.currentPage = +this.$route.query.page;
        // this.pageSize = +this.$route.query.size;
        this.currentPage = 1;
        this.pageSize = 9;
        this.totalPages = 8;

        if (this.$route.query.source) {
          this.source_selected = this.$route.query.source.split(',');
          // console.log(this.source_selected);
        }
        if (this.$route.query.project) {
          this.project_selected = this.$route.query.project.split(',');
          // console.log(this.project_selected);
        }
        if (this.$route.query.cancername) {
          this.cancer_selected = this.$route.query.cancername.split(',');
        }
        if (this.$route.query.genename) {
          this.gene_selected = this.$route.query.genename.split(',');
        }
        if (this.$route.query.astype) {
          this.as_selected = this.$route.query.astype.split(',');
        }
        if (this.$route.query.site) {
          this.site_selected = this.$route.query.site.split(',');
        }
        if (this.$route.query.dase) {
          this.dase_selected = this.$route.query.dase.split(',');
        }
        if (this.$route.query.dpsi) {
          this.dpsi_selected = this.$route.query.dpsi;
        }
        if (this.$route.query.fdr) {
          this.fdr_selected = this.$route.query.fdr;
        }
      }
    });
  },
  mounted() {
    // this.getAllProjectFromSpliceDataset()
    // this.getAllCancerFromSpliceDataset();
    // this.getAllGeneNamesFromGeneInfo();
  },
  watch: {
    filteredSpliceDatasets(val) {
      // console.log(val);
      if (val) {
        this.loading = false;
      }
    },
    // Source
    source_selected(newVal, oldVal) {
      // console.log(newVal);
      // console.log(oldVal);

      if (newVal !== oldVal) {
        // console.log('source changed');
        this.getSpliceDatasets();

        let project_items = [];
        let cancer_items = [];
        let site_items = [];
        newVal.forEach(val => {
          if (val == 'TCGA') {
            project_items.push(...this.project_list.filter(d => {
              if (d.startsWith("TCGA")) {
                return d
              }
            }));
            project_items = project_items.sort();
            // console.log(project_items);
            cancer_items.push("Adrenocortical Carcinoma", "Bladder Urothelial Carcinoma",
              "Breast Invasive Carcinoma", "Cervical Squamous Cell Carcinoma and Endocervical Adenocarcinoma",
              "Cholangiocarcinoma", "Colon Adenocarcinoma", "Lymphoid Neoplasm Diffuse Large B-cell Lymphoma",
              "Esophageal Carcinoma", "Glioblastoma Multiforme", "Head and Neck Squamous Cell Carcinoma",
              "Kidney Chromophobe", "Kidney Renal Clear Cell Carcinoma",
              "Kidney Renal Papillary Cell Carcinoma", "Brain Lower Grade Glioma",
              "Liver Hepatocellular Carcinoma", "Lung Adenocarcinoma", "Lung Squamous Cell Carcinoma",
              "Mesothelioma", "Ovarian Serous Cystadenocarcinoma", "Pancreatic Adenocarcinoma",
              "Pheochromocytoma and Paraganglioma", "Prostate Adenocarcinoma",
              "Rectum Adenocarcinoma", "Sarcoma", "Skin Cutaneous Melanoma",
              "Stomach Adenocarcinoma", "Testicular Germ Cell Tumors",
              "Thyroid Carcinoma", "Thymoma", "Uterine Corpus Endometrial Carcinoma",
              "Uterine Carcinosarcoma", "Uveal Melanoma"
            );
            site_items.push("Adrenal Gland", "Bladder", "Breast", "Cervix", "Liver", "Colon", "Lymph nodes",
              "Esophagus", "Brain", "Head and Neck", "Kidney", "Lung", "Heart", "Ovary", "Pancreas", "Prostate",
              "Soft Tissue", "Skin", "Stomach", "Testis", "Thyroid", "Thymus", "Uterus", "Eye"
            )
          } else if (val == 'GTEx') {
            project_items.push(...this.project_list.filter(d => {
              if (d.startsWith("GTEx")) {
                return d
              }
            }));
            project_items = project_items.sort();
            site_items.push(
              "Adipose", "Adrenal Gland", "Artery", "Bladder", "Brain", "Breast", "Cells", "Cervix", "Colon",
              "Esophagus", "Fallopian Tube", "Heart", "Kidney", "Liver", "Lung", "Minor Salivary Gland", "Muscle",
              "Nerve", "Ovary", "Pancreas", "Pituitary", "Prostate", "Skin", "Small Intestine", "Spleen", "Stomach",
              "Testis", "Thyroid", "Uterus", "Vagina", "Whole Blood"
            )
          } else if (val == 'GEO') {
            project_items.push(...this.project_list.filter(d => {
              if (d.startsWith("PRJ")) {
                return d
              }
            }));
            cancer_items.push("Primary Colorectal Cancer", "Breast Cancer", "Chronic Hepatitis B Virus associated Hepatocellular Carcinoma",
              "Esophageal Adenocarcinoma", "Prostate Cancer", "Colon Cancer", "Bladder Cancer", "Pancreatic Cancer", "Cervical squamous cell carcinoma",
              "Esophageal Squamou Cell Carcinoma", "Prostate Cancer", "Bladder Cancer", "Cervical Squamous Cell Carcinoma", "Oral Cancer",
              "Hereditary Leiomyomatosis And Renal Cell Carcinoma", "Papillary Thyroid Cancer", "Lung Cancer", "Gastric Cancer")
            site_items.push("Colon", "Breast", "Liver", "Esophagus", "Prostate", "Colon", "Bladder", "Pancrease", "Cervix", "Esophagus",
              "Prostate", "Bladder", "Cervix", "Gingiva", "Kidney", "Thyroid", "Lung", "Stomach")
          }
        })
        // console.log(project_items);
        this.project_items = [...new Set(project_items)];
        this.cancer_items = [...new Set(cancer_items)];
        this.site_items = [...new Set(site_items)];
      }

      if (newVal.length == 0) {
        this.source_selected_show = 2;

        this.project_items = this.project_list;
        this.cancer_items = this.cancer_list;
        this.site_items = this.site_list;
      }
    },

    //project id
    project_selected(val) {
      // console.log(val);
      // console.log(val.length);
      // console.log(this.project_list);
      if (val == null || val.length == 0) {
        this.project_selected_show = 2;
        this.project_message = "Please enter 1 or more Project IDs."

        this.getSpliceDatasets();
        // Check whether each project of project_selected is in the project_list array
      } else if (val && val.length > 0 && val.every(v => this.project_list.includes(v))) {
        this.project_selected = val;
        this.project_message = null;

        this.getSpliceDatasets();
      } else {
        // window.alert("Sorry, we cant' find the Project you entered.");
        // this.project_selected = [];
        this.project_selected && this.project_selected.pop();
      };
    },
    project_search(val) {
      val && val !== this.project_selected && this.projectQuerySelections(val);
    },

    // cancer type
    cancer_select(val) {
      if (val == null || val.length == 0) {
        this.cancer_items == this.cancer_list;
      }
    },
    cancer_search(val) {
      val && val !== this.cancer_select && this.cancerQuerySelections(val);
      if (val == null || val.length == 0) {
        this.cancer_items = this.cancer_list;
      }
    },
    cancer_selected(newVal, oldVal) {
      if (newVal.length == 0) {
        this.cancer_selected_show = 2;
      }
      if (newVal !== oldVal) {

        this.getSpliceDatasets();
      }
    },

    //gene name
    gene_selected(val) {
      // console.log(val);
      if (val == null || val.length == 0) {
        this.gene_selected_show = 3;
        this.gene_message = "Please enter 1 or more gene names."

        this.getSpliceDatasets();
        // Check whether each gene of gene_selected is in the gene_list array
      } else if (val && val.length > 0 && val.every(v => this.gene_list.includes(v))) {
        this.gene_selected = val;
        this.gene_message = null;

        this.getSpliceDatasets();
      } else {
        // window.alert("Sorry, we cant' find the Gene you entered.");
        // this.gene_selected = [];
        this.gene_selected && this.gene_selected.pop();
      };
    },
    gene_search(val) {
      val && val !== this.gene_selected && this.geneQuerySelections(val);
    },
    // as type
    as_selected(newVal, oldVal) {
      if (newVal.length == 0) {
        this.as_selected_show = 3;
      }
      if (newVal !== oldVal) {

        this.getSpliceDatasets();
      }
    },
    // primary site
    site_select(val) {
      if (val == null || val.length == 0) {
        this.site_items == this.site_list;
      }
    },
    site_search(val) {
      val && val !== this.site_select && this.siteQuerySelections(val);
      if (val == null || val.length == 0) {
        this.site_items = this.site_list;
      }
    },
    site_selected(newVal, oldVal) {
      if (newVal.length == 0) {
        this.site_selected_show = 3;
      }
      if (newVal !== oldVal) {

        this.getSpliceDatasets();
      }
    },
    dase_selected(newVal, oldVal) {
      if (newVal !== oldVal) {

        this.getSpliceDatasets();
      }
    },
    // Delta PSI
    dpsi_selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        // console.log(newVal);

        this.getSpliceDatasets();
      }
    },
    // FDR
    fdr_selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        // console.log(newVal);

        this.getSpliceDatasets();
      }
    },
    // watch multi data props meanwhile.
    listenMultiData(val) {
      // console.log(val);
      if (val.source_selected.length == 0 && val.project_selected.length == 0 &&
        val.cancer_selected.length == 0 && val.gene_selected.length == 0 &&
        val.as_selected.length == 0 && val.site_selected.length == 0 &&
        val.dase_selected.length == 0 && val.dpsi_selected == 0 &&
        val.fdr_selected == 0) {
        this.isShowTips = true; // Show the tips
      } else {
        this.isShowTips = false;
      }
    }
  },
  computed: {
    filteredSpliceDatasets() {
      return this.splice_datasets;
    },
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    },
    listenMultiData() { // watch multi data props meanwhile.
      const { source_selected, project_selected, cancer_selected, gene_selected, as_selected, site_selected,
        dase_selected, dpsi_selected, fdr_selected } = this;
      return {
        source_selected, project_selected, cancer_selected, gene_selected, as_selected, site_selected,
        dase_selected, dpsi_selected, fdr_selected
      }
    }
  },
  methods: {
    getRequestParams(source, project, genename, cancername, astype,
      site, dase, dpsi, fdr, page, pageSize, showPages) {
      let params = {};
      if (source.length > 0) {
        params["source"] = source.join(',');
      }

      if (project.length > 0) {
        params["project"] = project.join(',');
      }

      if (genename.length > 0) {
        params["genename"] = genename.join(',');
      }

      if (cancername.length > 0) {
        params["cancername"] = cancername.join(',');
      }

      if (astype.length > 0) {
        params["astype"] = astype.join(',');
      }

      if (site.length > 0) {
        params["site"] = site.join(',');
      }

      if (dase.length > 0) {
        params["dase"] = dase.join(',');
      }

      if (dpsi) {
        params["dpsi"] = dpsi;
      }
      if (fdr) {
        params["fdr"] = fdr;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      if (showPages) {
        params["showpages"] = showPages;
      }

      return params;
    },
    async getSpliceDatasets() {

      this.loading = true;

      // set default values for every request
      this.currentPage = 1;
      this.pageSize = 9;
      this.totalPages = 8;

      // console.log('hahaha');
      const params = this.getRequestParams(
        this.source_selected,
        this.project_selected,
        this.gene_selected,
        this.cancer_selected,
        this.as_selected,
        this.site_selected,
        this.dase_selected,
        this.dpsi_selected,
        this.fdr_selected,
        this.currentPage,
        this.pageSize,
        this.totalPages, // show pages
      );
      // console.log(params);

      await getSpliceDatasets(params).then(data => {
        if (data) {
          // console.log(data);
          this.loading = false;

          this.totalItems = data.totalItems;
          this.splice_datasets = data.items;
          this.currentPage = data.currentPage;
          this.totalPages = data.totalPages;
          this.hasPrevPage = data.hasPrevPage;
          this.hasNextPage = data.hasNextPage;
          this.prevPage = data.prevPage;
          this.nextPage = data.nextPage;

          this.$router.replace({
            path: '/browse/datasets',
            query: {
              source: params.source,
              project: params.project,
              genename: params.genename,
              cancername: params.cancername,
              astype: params.astype,
              site: params.site,
              dase: params.dase,
              dpsi: params.dpsi,
              fdr: params.fdr,
              page: params.page + 1,
              size: params.size,
              showpages: params.showpages,
            }
          }).catch(err => {
            if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But print any other errors to the console
              console.error(err);
            }
          });
        }
      }
      ).catch(err => console.error(err))
    },
    handlePageChange(value) {
      this.loading = true;

      this.currentPage = value;
      this.whichPage = this.currentPage;

      // 限制总页数，默认显示 8 页
      // if (value == this.totalPages) {
      //   this.totalPages++;
      // } else if (value < 8) {
      //   this.totalPages = 8;
      // }
      if (value == this.totalPages) {
        this.totalPages = value + 1;
      } else if (value < 8) {
        this.totalPages = 8;
      }

      // custom the request values for evading select the default values(1, 9, 8)
      const params = this.getRequestParams(
        this.source_selected,
        this.project_selected,
        this.gene_selected,
        this.cancer_selected,
        this.as_selected,
        this.site_selected,
        this.dase_selected,
        this.dpsi_selected,
        this.fdr_selected,
        this.currentPage,
        this.pageSize,
        this.totalPages, // show pages
      );

      getSpliceDatasets(params).then(data => {
        if (data) {
          // console.log(data);
          this.loading = false;

          this.totalItems = data.totalItems;
          this.splice_datasets = data.items;
          this.currentPage = data.currentPage;
          this.totalPages = data.totalPages;
          this.hasPrevPage = data.hasPrevPage;
          this.hasNextPage = data.hasNextPage;
          this.prevPage = data.prevPage;
          this.nextPage = data.nextPage;

          this.$router.replace({
            path: '/browse/datasets',
            query: {
              source: params.source,
              project: params.project,
              genename: params.genename,
              cancername: params.cancername,
              astype: params.astype,
              site: params.site,
              dase: params.dase,
              dpsi: params.dpsi,
              fdr: params.fdr,
              page: params.page + 1,
              size: params.size,
              showpages: params.showpages,
            }
          }).catch(err => {
            if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But print any other errors to the console
              console.error(err);
            }
          });
        }
      }).catch(err => console.error(err))
    },
    handlePageSizeChange(size) {

      // console.log(size);
      this.loading = true;

      this.currentPage = 1;
      this.totalPages = 8;

      // custom the request values for evading select the default values(1, 9, 8)
      const params = this.getRequestParams(
        this.source_selected,
        this.project_selected,
        this.gene_selected,
        this.cancer_selected,
        this.as_selected,
        this.site_selected,
        this.dase_selected,
        this.dpsi_selected,
        this.fdr_selected,
        this.currentPage,
        this.pageSize,
        this.totalPages, // show pages
      );
      // console.log(params);

      getSpliceDatasets(params).then(data => {
        if (data) {
          // console.log(data);
          this.loading = false;

          this.totalItems = data.totalItems;
          this.splice_datasets = data.items;
          this.currentPage = data.currentPage;
          this.totalPages = data.totalPages;
          this.hasPrevPage = data.hasPrevPage;
          this.hasNextPage = data.hasNextPage;
          this.prevPage = data.prevPage;
          this.nextPage = data.nextPage;

          this.$router.replace({
            path: '/browse/datasets',
            query: {
              source: params.source,
              project: params.project,
              genename: params.genename,
              cancername: params.cancername,
              astype: params.astype,
              site: params.site,
              dase: params.dase,
              dpsi: params.dpsi,
              fdr: params.fdr,
              page: params.page + 1,
              size: params.size,
              showpages: params.showpages,
            }
          }).catch(err => {
            if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But print any other errors to the console
              console.error(err);
            }
          });
        }
      }).catch(err => console.error(err))
    },
    // jumpPage() {
    //   // console.log(+this.whichPage);
    //   if (+this.whichPage < 1) {
    //     this.whichPage = 1;
    //   }
    //   if (+this.whichPage > this.totalPages) {
    //     this.whichPage = this.totalPages;
    //   }
    //   this.currentPage = +this.whichPage;

    //   this.getSpliceDatasets();
    // },
    showOrHide() {
      if (this.isShowFilter == true) {
        this.isShowFilter = false
        this.col2 = 12
      } else {
        this.isShowFilter = true
        this.col2 = 9
      }
    },
    // get all cancer types
    async getAllCancerFromSpliceDataset() {
      await getAllCancerFromSpliceDataset().then(data => {
        if (data) {
          // console.log(data);
          this.cancer_list = data.filter(d => d != "-" && d != "NA");
          this.cancer_items = this.cancer_list;
        }
      }).catch(err => console.error(err))
    },
    cancerQuerySelections(v) {
      this.cancer_error_message = null;
      this.cancer_loading = true;
      setTimeout(() => {
        this.cancer_items = this.cancer_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.cancer_loading = false;
        // show the no data tips when the search result is null
        if (this.cancer_items.length == 0) {
          this.cancer_error_message = "Sorry, we cant' find the Cancer Type you entered.";
        }
      }, 500)
    },
    showMoreCancer() {
      this.cancer_index = this.cancer_items.length;
    },
    showLessCancer() {
      this.cancer_index = 6;
    },
    refreshCancer() {
      // console.log(this.cancer_selected);
      this.cancer_selected = [];
    },

    refreshSource() {
      this.source_selected = [];
    },

    // get all projects
    async getAllProjectFromSpliceDataset() {
      await getAllProjectFromSpliceDataset().then(
        data => {
          if (data) {
            // console.log(data);
            // console.log(data.reverse());
            data = data.reverse(); // sort
            this.project_list = data;
            this.project_items = data;
          }
        }
      ).catch(err => console.error(err))
    },
    projectQuerySelections(v) {
      this.project_message = null;
      this.project_error_message = null;
      this.project_loading = true;
      setTimeout(() => {
        this.project_items = this.project_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.project_loading = false
        // show the no data tips when the search result is null
        if (this.project_items.length == 0) {
          this.project_error_message = "Sorry, we cant' find the Project ID you entered.";
        }
      }, 500)
    },
    refreshProject() {
      this.project_selected = [];
    },


    refreshASType() {
      this.as_selected = [];
    },

    refreshDASE() {
      this.dase_selected = [];
    },

    refreshDpsi() {
      this.dpsi_selected = 0;
    },

    refreshFDR() {
      this.fdr_selected = 0;
    },

    // get all gene names
    async getAllGeneNamesFromGeneInfo() {
      await getAllGeneNamesFromGeneInfo().then(data => {
        if (data) {
          this.gene_list = data;
        }
      }).catch(err => console.error(err))
    },
    geneQuerySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.gene_loading = false
        // show the no data tips when the search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find the Gene you entered.";
        }
      }, 500)
    },
    refreshGene() {
      this.gene_selected = [];
    },

    // get all primary sites
    async getAllPrimarySiteFromSpliceDataset() {
      await getAllPrimarySiteFromSpliceDataset().then(
        data => {
          if (data) {
            // console.log(data);
            this.site_list = data;
            this.site_items = this.site_list;
          }
        }
      ).catch(err => console.error(err))
    },
    siteQuerySelections(v) {
      this.site_error_message = null;
      this.site_loading = true;
      setTimeout(() => {
        this.site_items = this.site_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
          //   return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
        })
        this.site_loading = false;
        // show the no data tips when the search result is null
        if (this.site_items.length == 0) {
          this.site_error_message = "Sorry, we cant' find the Primary Site you entered.";
        }
      }, 500)
    },
    showMoreSite() {
      this.site_index = this.site_items.length;
    },
    showLessSite() {
      this.site_index = 6;
    },
    refreshSite() {
      this.site_selected = [];
    },
    refreshAll() {
      this.source_selected = [];
      this.project_selected = [];
      this.gene_selected = [];
      this.cancer_selected = [];
      this.as_selected = [];
      this.site_selected = [];
      this.dase_selected = [];
      this.dpsi_selected = 0;
      this.fdr_selected = 0;
    },
    addDeleteLine($event) {
      $event.currentTarget.classList.add('show-delete-line');
    },
    removeDeleteLine($event) {
      $event.currentTarget.classList.remove('show-delete-line');
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router.push({
          path: '/search',
          query: {
            genename: genename,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (genename == null || genename == '') {
        window.alert("Sorry, please input the gene name !")
      }
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/regexp',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/survival/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/stage/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['BioProject', 'Gene Name', 'Cancer Type',
        'AS Type', 'ORF', 'PSI Tumor', 'PSI Normal', 'Delta PSI', 'FDR',
        'DASE', 'Visualization', 'Explorer', 'Survival', 'Staging'];
    },
  },

}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.disable-cursor
  cursor: auto

.v-sheet.v-card
  border-radius: 15px

// .theme--light.v-data-table .v-data-footer
//   border-top: 0

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.show-delete-line
  text-decoration: line-through

.pagesize-select
  max-width: 8%

.jump-select
  max-width: 8%

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>